import React from 'react';
import { Link } from 'react-router-dom';
import { BrandIcon } from './BrandIcon';

/**
 * Dark colophon footer for intrnauts.ai. Renders BrandIcon again — this is
 * the canary that exercises Pitfall 4 (gradient id collision when two SVGs
 * share an id). With useId() it must NOT collide.
 */
export const AiFooter: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="ai-footer-colophon">
      <div className="ai-footer-brand">
        <span className="brand-mark">
          <BrandIcon className="brand-icon" height={24} />
          <span className="dot" aria-hidden="true" />
        </span>
        <span className="wordmark">intrnauts.ai</span>
      </div>
      <p className="ai-footer-line">
        An independent studio building AI that earns its keep.
      </p>
      <p className="ai-footer-line">
        &copy; {year} intrnauts.ai · <Link to="/contact">hello@intrnauts.ai</Link>
      </p>
    </footer>
  );
};

export default AiFooter;
